import { queryOptions } from '@tanstack/react-query'
import { getCurrentUser } from './api'

export const currentUserQueryKey = ['auth', 'me'] as const

export const currentUserQueryOptions = () =>
  queryOptions({
    queryKey: currentUserQueryKey,
    queryFn: getCurrentUser,
    staleTime: 5 * 60 * 1000,
  })
